module.exports = __webpack_public_path__ + "static/media/apply-success.63f8a2fc.png";